import { h, Fragment } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import styles from './MobileFilter.module.scss';
import { Close } from '../icons/close';
import { Caret } from '../icons/caret';
export function MobileFilter({ isOpen, onClose, filters, onFilterChange, sortOptions, currentSort, onSortChange, initialOpenFilter, productCount = 0, onClearAll, }) {
    // Track which filter groups are open (all closed by default)
    const [openGroups, setOpenGroups] = useState(new Set());
    // Track if sort section is open
    const [isSortOpen, setIsSortOpen] = useState(false);
    // Ref to store filter group elements for scrolling
    const filterRefs = useRef({});
    // Open the initial filter when drawer opens
    useEffect(() => {
        if (isOpen && initialOpenFilter) {
            // Check if we should open Sort section
            if (initialOpenFilter === 'sort') {
                setIsSortOpen(true);
            }
            else {
                setOpenGroups(new Set([initialOpenFilter]));
                // Scroll to the filter group after drawer animation completes (300ms) + render time
                setTimeout(() => {
                    const filterElement = filterRefs.current[initialOpenFilter];
                    if (filterElement) {
                        // Scroll within the drawer content container
                        const drawerContent = filterElement.closest(`.${styles.drawerContent}`);
                        if (drawerContent) {
                            const elementTop = filterElement.offsetTop;
                            drawerContent.scrollTo({
                                top: elementTop - 72, // 20px offset from top
                                behavior: 'smooth'
                            });
                        }
                    }
                }, 400);
            }
        }
        else if (!isOpen) {
            // Reset when drawer closes
            setOpenGroups(new Set());
            setIsSortOpen(false);
        }
    }, [isOpen, initialOpenFilter]);
    // Prevent body scroll when drawer is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);
    if (!isOpen)
        return null;
    const handleSortSelect = (sortId) => {
        onSortChange(sortId);
    };
    const toggleGroup = (filterId) => {
        setOpenGroups((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(filterId)) {
                newSet.delete(filterId);
            }
            else {
                newSet.add(filterId);
            }
            return newSet;
        });
    };
    return (h(Fragment, null,
        h("div", { class: styles.overlay, onClick: onClose }),
        h("div", { class: styles.drawer },
            h("div", { class: styles.drawerHeader },
                h("h2", { class: styles.drawerTitle }, "Filter & Sort"),
                h("button", { class: styles.closeButton, onClick: onClose, "aria-label": "Close" },
                    h(Close, null))),
            h("div", { class: styles.drawerContent },
                h("div", { class: styles.section },
                    h("div", { class: styles.filterGroup },
                        h("button", { class: styles.filterHeader, onClick: () => setIsSortOpen(!isSortOpen), type: "button" },
                            h("h4", { class: styles.filterTitle }, "Sort"),
                            h(Caret, { isOpen: isSortOpen })),
                        isSortOpen && (h("div", { class: styles.sortList }, sortOptions.map((option) => (h("label", { key: option.id, class: styles.radioLabel },
                            h("input", { type: "radio", name: "sort", checked: option.id === currentSort, onChange: () => handleSortSelect(option.id) }),
                            h("span", { class: styles.customRadio }),
                            h("span", { class: styles.radioText }, option.label)))))))),
                h("div", { class: styles.section },
                    h("div", { class: styles.filterList }, filters
                        .filter((filter) => filter.type !== 'range')
                        .map((filter) => {
                        var _a;
                        const isOpen = openGroups.has(filter.id);
                        return (h("div", { key: filter.id, class: styles.filterGroup, ref: (el) => {
                                filterRefs.current[filter.id] = el;
                            } },
                            h("button", { class: styles.filterHeader, onClick: () => toggleGroup(filter.id), type: "button" },
                                h("h4", { class: styles.filterTitle }, filter.label),
                                h(Caret, { isOpen: isOpen })),
                            isOpen && (h("div", { class: styles.filterOptions }, (_a = filter.options) === null || _a === void 0 ? void 0 : _a.map((option) => (h("label", { key: option.id, class: styles.checkboxLabel },
                                h("input", { type: "checkbox", checked: option.selected, onChange: () => onFilterChange(filter.id, option.id) }),
                                h("span", { class: filter.type === 'color' ? styles.customColorCheckbox : styles.customCheckbox }),
                                h("span", { class: styles.checkboxText }, option.label))))))));
                    })))),
            h("div", { class: styles.drawerFooter },
                h("button", { class: styles.viewButton, onClick: onClose },
                    "View ",
                    productCount,
                    " ",
                    productCount === 1 ? 'item' : 'items'),
                h("button", { class: styles.clearButton, onClick: () => {
                        if (onClearAll) {
                            onClearAll();
                        }
                    } }, "Clear all")))));
}
